import { Component, Vue } from 'vue-property-decorator';

@Component<RequestButtonCreate>({})
export default class RequestButtonCreate extends Vue { }
